import { render, staticRenderFns } from "./PurchaseItem.vue?vue&type=template&id=3d5fda5e&scoped=true&"
import script from "./PurchaseItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseItem.vue?vue&type=style&index=0&id=3d5fda5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5fda5e",
  null
  
)

export default component.exports